import React from 'react';
import * as pt from 'prop-types';
import { useSelector } from 'react-redux'
// import createReactClass from 'create-react-class';

import { Modal } from 'react-bootstrap';
// import Modal from '../../../common/components/Modal';
import Loader from '../../../common/components/notifications/Loader';
import { getHasRequestPending } from '../../../redux/data/selectors';

function ImageAssetModal(props) {
  const isResolving = useSelector((state) =>
    getHasRequestPending(state, 'API_REQUEST_assets_get')
  )
  return (
    <Modal onHide={props.onHide} show={props.show}>
      <Modal.Header>Images</Modal.Header>

      <Modal.Body className='container-fluid'>
        {isResolving > 0 ? (
          <Loader message='Loading' />
        ) : props.assets.data.length === 0 ? (
          <div className='alert alert-info'>
            You don't have any image assets
          </div>
        ) : (
          <ul className='list-unstyled row' style={{ padding: '1em' }}>
            {props.assets.data.map(function (asset) {
              return (
                <AssetImage
                  key={asset.assetID}
                  asset={asset}
                  onSelect={props.onSelect}
                />
              )
            })}
          </ul>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          className='btn btn-default'
          onClick={(ev) => {
            ev.preventDefault()
            props.onHide()
          }}
        >
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  )
}

ImageAssetModal.propTypes = {
    onSelect: pt.func.isRequired,
    assets: pt.shape({
        resolving: pt.array,
        data: pt.array
    }),

    // for bootstrap modal
    show: pt.bool,
    onHide: pt.func
};

function AssetImage (props) {
    var asset = props.asset;
    function click (ev) {
        ev.preventDefault();
        props.onSelect(props.asset);
    }

    return <li className="col-sm-6 col-md-4 callout ott-asset-card">
        <img className="img-responsive" src={asset.fileUrl} alt={asset.name} />
        <ul className="list-unstyled">
            <li>{asset.name}</li>
            <li>{asset.advancedDetails.image[0].width} × {asset.advancedDetails.image[0].height}</li>
            <li className="text-right">
                <button className="btn btn-primary" onClick={click}>
                    <span className="glyphicon glyphicon-ok" aria-hidden="true"></span>
                </button>
            </li>
        </ul>
    </li>;
}

export default ImageAssetModal;
